import { useTranslation } from 'react-i18next';
import { haptic } from '../../lib/haptic';

type Props = {
  value: number;
  onChange: (rating: number) => void;
  max?: number;
};

export function RatingStars({ value, onChange, max = 5 }: Props) {
  const { t } = useTranslation('common');
  return (
    <div role="radiogroup" aria-label={t('rating_aria')} className="flex gap-1 items-center justify-center">
      {Array.from({ length: max }, (_, i) => {
        const star = i + 1;
        const filled = star <= value;
        return (
          <button
            key={star}
            type="button"
            role="radio"
            aria-checked={star === value}
            aria-label={`${star} ${t('rating_star')}`}
            data-testid={`rating-star-${star}`}
            onClick={() => { haptic.tap(); onChange(star); }}
            className={`text-3xl transition-transform active:scale-90 ${filled ? 'text-[#F59E0B]' : 'text-[var(--color-border,#d1d5db)]'}`}
          >
            {filled ? '★' : '☆'}
          </button>
        );
      })}
    </div>
  );
}
